import { InjectionToken, signal, Signal } from '@angular/core';

/**
 * Abstraction the store depends on instead of a concrete, tenant-specific service —
 * decouples the shared prediction-game store from how each host app determines which
 * fixture to show first.
 */
export interface MatchContext {
  /** Id of the fixture the host app wants to show first; null = default selection. */
  readonly heimspielId: Signal<string | null>;
}

export const MATCH_CONTEXT = new InjectionToken<MatchContext>('MATCH_CONTEXT');

/**
 * Context for tenants whose host app never deep-links a specific match: the fixture
 * selection then always falls back to the next tippable match.
 */
export const NO_MATCH_CONTEXT: MatchContext = { heimspielId: signal(null).asReadonly() };
